/**
 * @module evidenceCard
 */

const React = require('react');
const SharedModels = require('../../../shared/sharedModels');
const SharedConstants = require('../../../shared/sharedConstants');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./redux/reduxStore.jsx.js');

const AjaxFunctions = require('./ajaxFunctions.js');
const Utils = require('./utils.js');
const Link = require('react-router-dom').Link;
const CardComments = require('./components/cardComments.jsx').CardComments;
const ToastAlert = require('./components/toastAlert');

import MPubCard, { MPubCardSkeleton } from './components/mPubCard';
import CardFunctions from './components/cardFunctions';
import { ApprovalControl } from './evidenceReview.jsx';
import { Button } from "@material-ui/core";

export class CardMainContainer extends React.Component{
   constructor(props) {
      super(props);
      this.state = { isLoading: true }
   }

   componentDidMount() {
      window.globals.idCard = Utils.getParameterByName('idCard', window.location.href);
      if(window.globals.idCard && !ReduxStore.store.getState().EditorReducer.isEditing) {
         this.updateCardData(window.globals.idCard)
            .then(() => this.setState({ isLoading: false }))
            .catch(err => ToastAlert.error(err));
      }
   }

   async createComment(text) {
      await AjaxFunctions.createCardComment(SharedConstants.CardType.Evidence, this.props.curCard.id, null, text, this.props.currentPortfolio);
      await this.updateCardData(this.props.curCard.id);
   }

   deleteCard() {
      AjaxFunctions.deleteEvidenceCard(this.props.curCard.id).then(() => 
         window.location='/listView'
      );
   }

   async deleteComment(idCardComment) {
      await AjaxFunctions.deleteCardComment(idCardComment);
      await this.updateCardData(this.props.curCard.id);
   }

   async updateCardData(idCard) {
      let data = await AjaxFunctions.getEvidenceCardByID(idCard);

      let idIncubator = Utils.getParameterByName('idIncubator', window.location.href);
      if(idIncubator){
         let entry = await AjaxFunctions.getArpahSubmissionsForCardInIncubator(idIncubator, idCard);
         if(entry.length > 0){
            data.arpahEntry = entry[0];
         }
      }
      ReduxStore.store.dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(new SharedModels.EvidenceCard(data)));
   }

   async createUpvote() {
      await AjaxFunctions.createUpvote(this.props.curCard.id, this.props.curCard.cardType);
      await this.updateCardData(this.props.curCard.id);
   }

   render() {
      const { curCard, idCurUser } = this.props;
      const { isLoading } = this.state;

      if (isLoading) return <MPubCardSkeleton />;

      let cardSource = this.props.curCard.source;
      if(cardSource && !cardSource.includes('http://') && !cardSource.includes('https://')){
         cardSource = 'http://' + cardSource;
      }

      let returnUrl = this.props.returnUrl || window.location.pathname;
      let idParentConjecture = Utils.getParameterByName('idParentConjecture', window.location.href);
      if(idParentConjecture){
         returnUrl += (returnUrl.includes('?') ? '&' : '?')
            + `cardType=2&idCard=${idParentConjecture}&cModalOpen=1`
      }

      return (
         <div className='evidenceCard'>
            <MPubCard disableLink card={curCard} />
            {!curCard.isApproved && 
               <ApprovalControl 
                  idCard={curCard.id} 
                  closeFunction={this.props.closeFunction} 
               />
            }
            {window.globals.idUser &&
               <div className='card-modal-actions'>
                  <div className='published'>
                        <Button
                           className='upvote-btn'
                           onClick={() => this.createUpvote()}
                           style={{ textTransform: 'none' }}
                           startIcon={<span>{curCard.upvoteCount || 0}</span>}
                           disabled={curCard.idUpvoteForCurrentUser > 0 || curCard.idUser == window.globals.idUser}
                           color='primary'
                           variant='contained'
                           size='medium'
                        >
                           <div>Good Evidence!</div>
                        </Button>
                        {idCurUser && <CardFunctions card={curCard} />}
                     </div>
                     {(window.globals.isAdmin)  && ( 
                     <div className='under-review'>
                        <Button 
                           onClick={() => this.deleteCard()}
                           style={{ textTransform: 'none' }}
                           color='secondary'
                           variant='contained'
                           size='medium'
                        >
                           <div>Delete</div>
                        </Button>
                     </div>
                  )}
                  {this.props.showComments && 
                     <CardComments 
                        idSubmitter={this.props.idSubmitter}
                        comments={this.props.curCard.comments}
                        currentPortfolio={this.props.currentPortfolio}
                        createCommentFunction={text => this.createComment(text)}
                        deleteCommentFunction={idCardComment => this.deleteComment(idCardComment)}
                        currentCard={curCard}
                     />
                  }
               </div>
            }
         </div>
      );
   }
}

const mapCardMainContainerStateToProps = (state) => {
   return {
      isEditing: state.EditorReducer.isEditing,
      curCard: state.EvidenceCardReducer.curCard,
      idCurUser: state.UserReducer.curUser.id,
   }
};

export default connect(
   mapCardMainContainerStateToProps,
   () => {}
)(CardMainContainer);


